import { CircularProgress, Grid } from "@material-ui/core";
import { assetsUrl } from "../../../common/config";
import { LearningPathCards, OtherCourses } from "../../../components";
import { CourseBffApi, LearningPathBffApi } from "../../../models/api";
import { Status } from "../../../models/gameplan";
import { useCourseProgress } from "../../../shared/hooks";
import { StartJourney } from "../../components";
import { useStyles } from "./learning-tab.styles";

const journeyImage = `${assetsUrl}/learning/startJourneyImg.svg`;
const CompletedModuleMessage =
  "You've completed this part of the course! Check out another course while we add more content.";

type Props = {
  learningPath: LearningPathBffApi;
  course: CourseBffApi;
  includeLearningPathCards?: boolean;
};

export const LearningTab = ({
  learningPath,
  course,
  includeLearningPathCards,
}: Props) => {
  const classes = useStyles();
  const { data: courseProgress, isFetching } = useCourseProgress();

  const courseData = courseProgress || course;

  if (isFetching) {
    return (
      <Grid className={classes.loading}>
        <CircularProgress />
      </Grid>
    );
  }

  const isAllCompleted = courseData.modules.every(
    (module) => module.status === Status.COMPLETED
  );

  const courseName = isAllCompleted
    ? CompletedModuleMessage
    : `${learningPath.name}: ${courseData.name}`;

  return (
    <Grid className={classes.container}>
      <Grid item xs={12}>
        {courseData.modules.length ? (
          <StartJourney
            isAllCompleted={isAllCompleted}
            courseName={courseName}
            imageUrl={journeyImage}
            modules={courseData.modules}
          />
        ) : null}
      </Grid>
      <OtherCourses
        learningPathId={learningPath.id}
        activeCourseId={courseData.id}
      />
      {includeLearningPathCards ? <LearningPathCards /> : null}
    </Grid>
  );
};
